import {RailsPartial} from '@github-ui/rails-partial'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {PageLayout} from '@primer/react'

import {reactSandboxFutureRailsPartialsRoute} from './rails-partials-route'

export function RailsPartials() {
  const {
    data: {serverTime},
  } = useRouteQuery(reactSandboxFutureRailsPartialsRoute, 'mainQuery')

  return (
    <>
      <PageLayout>
        <PageLayout.Header>
          <h2>
            ReactSandboxRailsPartials{' '}
            <RailsPartial partialName="HeadContent" route={reactSandboxFutureRailsPartialsRoute} />
          </h2>
        </PageLayout.Header>
        <PageLayout.Content>
          <p>Server time: {serverTime}</p>
          <RailsPartial partialName="LeftContent" route={reactSandboxFutureRailsPartialsRoute} />
        </PageLayout.Content>
        <PageLayout.Pane>
          <RailsPartial partialName="RightContent" route={reactSandboxFutureRailsPartialsRoute} />
        </PageLayout.Pane>
      </PageLayout>
    </>
  )
}

try{ RailsPartials.displayName ||= 'RailsPartials' } catch {}